import React, { useState } from "react";
import { motion } from "framer-motion";

import { AppWrap, MotionWrap } from "../../wrapper";
import "./Work.scss";
import { images } from "../../constants";

const data = [
  {
    _type: "works",
    description: "Shop Advertising Board",
    imgUrl: images.shop_sign_board,
    tags: ["Shop Sign Board", "All"],
    title: "Royal Tailors",
  },
  {
    _type: "works",
    description: "Shop Advertising Board",
    imgUrl: images.eng_hindi_marathi_service,
    tags: ["Shop Sign Board", "All"],
    title: "Dr. Kalyani Kante's Hospital",
  },

  {
    _type: "works",
    description: "Wall Advertising",
    imgUrl: images.wall_advertising,
    tags: ["Wall Advertising", "All"],
    title: "Baalvikas Vidya Mandir",
  },
  {
    _type: "works",
    description: "Wall Advertising",
    imgUrl: images.wall_advertising1,
    tags: ["Wall Advertising", "All"],
    title: "Mauli Apartment",
  },

  {
    _type: "works",
    description: "Building Name Board",
    imgUrl: images.building_name_board04,
    tags: ["Building Name Board", "All"],
    title: "Snehadhara Society",
  },
  {
    _type: "works",
    description: "Building Name Board",
    imgUrl: images.building_name_board02,
    tags: ["Building Name Board", "All"],
    title: "Siddhivinayak Apartment",
  },
  // {
  //   _type: "works",
  //   description: "Building Name Board",
  //   imgUrl: images.building_name_board,
  //   tags: ["Building Name Board", "All"],
  //   title: "Police Station Name Plates",
  // },
  // {
  //   _type: "works",
  //   description: "Building Name Board",
  //   imgUrl: images.building_name_board01,
  //   tags: ["Building Name Board", "All"],
  //   title: "Police Station",
  // },
  {
    _type: "works",
    description: "Building Name Board",
    imgUrl: images.building_name_board03,
    tags: ["Building Name Board", "All"],
    title: "Shivar Plaza Society",
  },

  {
    _type: "works",
    description: "Banner Advertising",
    imgUrl: images.banner,
    tags: ["Banner Advertising", "All"],
    title: "Mandir Banner",
  },

  {
    _type: "works",
    description: "Name Plate / Number Plate",
    imgUrl: images.name_plate,
    tags: ["Name Plate", "All"],
    title: "Electric Info Name Plate",
  },
];

const Work = () => {
  const [works] = useState(data);
  const [filterWork, setFilterWork] = useState(data);
  const [activeFilter, setActiveFilter] = useState("All");
  const [animateCard, setAnimateCard] = useState({ y: 0, opacity: 1 });

  // useEffect(() => {
  //   const query = '*[_type == "works"]';

  //   client.fetch(query).then((data) => {
  //     setWorks(data);
  //     setFilterWork(data);
  //   });
  // }, []);

  const handleWorkFilter = (item) => {
    setActiveFilter(item);
    setAnimateCard([{ y: 100, opacity: 0 }]);

    setTimeout(() => {
      setAnimateCard([{ y: 0, opacity: 1 }]);

      if (item === "All") {
        setFilterWork(works);
      } else {
        setFilterWork(works.filter((work) => work.tags.includes(item)));
      }
    }, 500);
  };

  return (
    <>
      <h2 className="head-text">
        My <span>Work</span> Gallery
      </h2>

      <div className="app__work-filter">
        {[
          "Shop Sign Board",
          "Wall Advertising",
          "Building Name Board",
          "Name Plate",
          "Banner Advertising",
          "All",
        ].map((item, index) => (
          <div
            key={index}
            onClick={() => handleWorkFilter(item)}
            className={`app__work-filter-item app__flex p-text ${
              activeFilter === item ? "item-active" : ""
            }`}
          >
            {item}
          </div>
        ))}
      </div>

      <motion.div
        animate={animateCard}
        transition={{ duration: 0.5, delayChildren: 0.5 }}
        className="app__work-portfolio"
      >
        {filterWork.map((work, index) => (
          <div className="app__work-item app__flex" key={index}>
            <div className="app__work-img app__flex">
              <img src={work.imgUrl} alt={work.name} />
            </div>

            <div className="app__work-content app__flex">
              <h4 className="bold-text">{work.title}</h4>
              <p className="p-text" style={{ marginTop: 10 }}>
                {work.description}
              </p>

              <div className="app__work-tag app__flex">
                <p className="p-text">{work.tags[0]}</p>
              </div>
            </div>
          </div>
        ))}
      </motion.div>
    </>
  );
};

export default AppWrap(
  MotionWrap(Work, "app__works"),
  "work",
  "app__primarybg"
);
